import React from 'react';

const replaceText = () => {
  const elementsWithViewCategory = document.querySelectorAll('.pageTitle'); // Select all elements, you can narrow it down based on your application structure.

  elementsWithViewCategory.forEach((element) => {
    // Check if the element's text content includes the placeholder
    if (
      element.textContent &&
      element.textContent.includes('[VIEW_CATEGORY]')
    ) {
      const updatedText = element.textContent.replace('[VIEW_CATEGORY]', 'id');
      element.textContent = updatedText;
    }
  });
};

export default replaceText;
